import EmptyAssets from './EmptyAssets';

export default EmptyAssets;
